module.exports = __webpack_public_path__ + "img/rascrut-2.343240cc.webp";